// extracted by mini-css-extract-plugin
export default {"root":"juqxlK","large":"lXt5dO","media":"GJykEm","thumbnail":"cOXfvl","layout":"q9uiAI"};